export default "__VITE_ASSET__DIFi0AIL__"